module.exports = __webpack_public_path__ + "static/media/calc-background.c3e8bb31.jpg";